// extracted by mini-css-extract-plugin
export default {"footer-links":"footer-links__FXF57","copy":"copy__AFcBD"};